module.exports = __webpack_public_path__ + "img/97.10.8abde34b.png";